<div class="spin-row" *ngIf="show">
  <div class="bk-spin"></div>
  <span class="muted fz12" *ngIf="label">{{ label }}</span>
</div>
